import React from "react";
import  { withStyles } from  '@material-ui/core/styles';
import { inject, observer } from "mobx-react";
import Iframe from 'react-iframe'
import Paper from '@material-ui/core/Paper';

const styles = theme => ({
  filterBar: {
    backgroundColor: '#222222',
    height: 45, 
    position:'absolute'
  }
})


@inject("authStore", "commonStore")
@observer
class Analytics extends React.Component {
  constructor(props, context) {
    super(props, context);
        this.state = {

        }
    }
  componentDidMount() {
        this.updateWindowDimensions();
        window.addEventListener('resize', this.updateWindowDimensions);
      }
      componentWillUnmount() {
        window.removeEventListener('resize', this.updateWindowDimensions);
      }
    
  updateWindowDimensions = () => {
    // document.removeEventListener('keydown', this.onKeydown);
    const width = window.innerWidth;
    const height = window.innerHeight;

    this.setState({ height, width });
  }
render(){
    const { classes, authStore } = this.props
    const { width, height } = this.state
    const { userSessionToken } = authStore



    return (
        <div style={{width, height, marginLeft:-25, marginTop:-20 }}>
        <Iframe url={`https://search-sonic-public-hxpqpqo22jq3glsfkw2oqdtoxq.us-east-1.es.amazonaws.com/_plugin/kibana/app/kibana#/dashboard/84ddec90-d0d8-11e8-8627-114b46fb9795?embed=true&_g=(refreshInterval%3A(pause%3A!f%2Cvalue%3A300000)%2Ctime%3A(from%3Anow%2Fd%2Cmode%3Aquick%2Cto%3Anow%2Fd))&token=${userSessionToken}`}
        width={`${width}px`}
        height={`${height}px`}
        id={'board'}
        display="initial"
        allowFullScreen/>
        <Paper style={{width}}
        className={classes.filterBar}
        />
        </div>
    )

}

}

export default withStyles(styles)(Analytics);


// WEBPACK FOOTER //
// ./src/components/Leads/Analytics/index.js